/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();

    // fix delayed image restore
    this.imageObserver = new MutationObserver(() => {
      theme.manuallyLoadImages(this);
    });

    this.imageObserver.observe(this, {
      childList: true,
      subtree: true
    });
    // end fix delayed image restore
  }

 bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      setTimeout(enforceCartQuantityLimits, 50);
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      setTimeout(enforceCartQuantityLimits, 30);
    });
  }

  disconnectedCallback() {
    // clean up connectedCallback() observer
    if (this.imageObserver) {
      this.imageObserver.disconnect();
    }

    this.cartRefreshHandler = this.cartRefreshHandler.bind(this);

    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  } 

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);

async function enforceCartQuantityLimits() {
  const cartContainer = document.querySelector('cart-drawer') || document.querySelector('cart-form');
  if (!cartContainer) return;
  const customerTags = (document.body.dataset.customerTags || '').split(',');
  const isWholesale = customerTags.includes('wholesale');
  
  if (isWholesale) {
    return;
  }
  try {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    const productTotals = {};
    cart.items?.forEach(item => {
      const pid = item.product_id;
      if (!productTotals[pid]) {
        productTotals[pid] = { total: 0, variantIds: new Set() };
      }
      productTotals[pid].total += item.quantity;
      productTotals[pid].variantIds.add(item.variant_id);
    });

    cartContainer.querySelectorAll('[data-product-id][data-quantity-limit]').forEach(row => {
      const productId = parseInt(row.dataset.productId);
      const limit = parseInt(row.dataset.quantityLimit);
      const productData = productTotals[productId];

      if (!productData || !limit || limit >= 999) return;

      const isAtLimit = productData.total >= limit;

      const incrementBtn = row.querySelector('a.quantity-up');
      const decrementBtn = row.querySelector('a.quantity-down'); 
      const qtyInput = row.querySelector('input.cart-item__quantity-input, input[name="updates[]"]');

      if (incrementBtn) {
        incrementBtn.disabled = isAtLimit;
        incrementBtn.setAttribute('aria-disabled', isAtLimit ? 'true' : 'false');
        incrementBtn.classList.toggle('is-disabled', isAtLimit);
        
        // Tooltip 
        if (isAtLimit) {
          incrementBtn.title = `Maximum ${limit} ${limit === 1 ? 'item' : 'items'} allowed per order`;
        } else {
          incrementBtn.removeAttribute('title');
        }
      }

    
    });

  } catch (e) {
    console.error('enforceCartQuantityLimits error:', e);
  }
}


/**
 * Robust Quantity Limiter for Shopify
 * Handles: Standard Cart, Product Page Forms, and Rebuy Cart Drawer.
 * Bypasses limits for Wholesale/B2B customers.
 */
( function() {
  'use strict';

  const WHOLESALE_TAGS = ['wholesale'];
  const LIMIT_TAG_PREFIX = 'script-order-limit-';
  const productLimitsCache = {};

  // --- 1. CHECK IF WHOLESALE ---
  function isWholesale() {
    const tagsStr = document.body.dataset.customerTags || '';
    if (!tagsStr) return false;
    const tags = tagsStr.split(',').map(t => t.trim().toLowerCase());
    return WHOLESALE_TAGS.some(wTag => tags.includes(wTag));
  }

  // --- 2. GET LIMIT (Async with Cache) ---
  async function getLimit(handle) {
    if (productLimitsCache[handle] !== undefined) {
      return productLimitsCache[handle];
    }
    try {
      const res = await fetch(`/products/${handle}.js`);
      const data = await res.json();
      const tag = data.tags?.find(t => t.startsWith(LIMIT_TAG_PREFIX));
      const limit = tag ? parseInt(tag.replace(LIMIT_TAG_PREFIX, ''), 10) : null;
      productLimitsCache[handle] = limit;
      return limit;
    } catch (e) {
      return null;
    }
  }

  // --- 3. STANDARD CART & PDP INTERCEPTION ---
  function initStandardInterception() {
    if (isWholesale()) return;

    // A. Intercept Product Form Submission (PDP)
    document.addEventListener('submit', function(e) {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;

      const limit = form.dataset.quantityLimit ? parseInt(form.dataset.quantityLimit, 10) : null;
      if (!limit) return;

      const qtyInput = form.querySelector('input[name="quantity"]');
      const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

      if (qty > limit) {
        e.preventDefault();
        alert(`Maximum order quantity for this item is ${limit}.`);
        if (qtyInput) {
          qtyInput.value = limit;
          qtyInput.dispatchEvent(new Event('change'));
        }
      }
    }, true); // Use capture phase to intercept early

    // B. Intercept Standard Cart Buttons (.quantity-up / .quantity-down)
    // We attach listener to body to catch dynamic updates
        // B. Intercept Standard Cart Buttons (.quantity-up / .quantity-down)
    document.body.addEventListener('click', function(e) {
      const btn = e.target.closest('.quantity-up, .quantity-down');
      if (!btn) return;

      // Если кнопка уже заблокирована UI — останавливаем
      if (btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        return;
      }

      const row = btn.closest('.cart-item, [data-product-id]');
      if (!row) return;

      const productId = row.dataset.productId;
      const limitAttr = row.dataset.quantityLimit;
      
      if (!limitAttr) return; 
      const limit = parseInt(limitAttr, 10);
      if (!limit) return;

      const isPlus = btn.classList.contains('quantity-up') || btn.getAttribute('aria-label')?.includes('Increase');
      
      if (isPlus) {
        let totalQtyInCart = 0;
        
        const allRowsWithSameProduct = document.querySelectorAll(`.cart-item[data-product-id="${productId}"], [data-product-id="${productId}"]`);
        
        allRowsWithSameProduct.forEach(r => {
          const input = r.querySelector('input.cart-item__quantity-input, input[name="updates[]"]');
          if (input) {
            totalQtyInCart += parseInt(input.value, 10) || 0;
          }
        });

        if (totalQtyInCart >= limit) {
          e.preventDefault();
          e.stopPropagation();
          
          allRowsWithSameProduct.forEach(r => {
            const plusBtn = r.querySelector('.quantity-up');
            if (plusBtn) {
              plusBtn.classList.add('is-disabled');
              plusBtn.setAttribute('aria-disabled', 'true');
              plusBtn.title = `Maximum ${limit} items allowed per product`;
            }
          });
          
          return false;
        }
      }
    }, true);
  }
  // --- 4. REBUY CART INTERCEPTION ---
  async function checkRebuyLimits() {
    if (isWholesale()) {
      // Enable all buttons for wholesale
      document.querySelectorAll('.rebuy-cart__flyout-item-quantity-widget-button').forEach(btn => {
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
      });
      return;
    }

    const items = document.querySelectorAll('.rebuy-cart__flyout-item');
    for (const item of items) {
      await processRebuyItem(item);
    }
  }

  async function processRebuyItem(itemEl) {
    const link = itemEl.querySelector('a[href*="/products/"]');
    if (!link) return;
    
    const handle = link.href.split('/products/')[1].split('?')[0];
    const limit = await getLimit(handle);
    if (!limit) return;

    let totalQty = 0;
    const allItems = document.querySelectorAll('.rebuy-cart__flyout-item');
    
    for (const item of allItems) {
      const itemLink = item.querySelector('a[href*="/products/"]');
      if (!itemLink) continue;
      
      const itemHandle = itemLink.href.split('/products/')[1].split('?')[0];
      if (itemHandle === handle) {
        const labelSpan = item.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');
        if (labelSpan) {
          const qtyText = labelSpan.innerText || labelSpan.textContent;
          totalQty += parseInt(qtyText.replace(/[^0-9]/g, ''), 10) || 0;
        }
      }
    }

    const plusBtn = itemEl.querySelector('button[aria-label*="Increase"]');
    
    if (totalQty >= limit) {
      if (plusBtn) {
        plusBtn.disabled = true;
        plusBtn.setAttribute('aria-disabled', 'true');
        plusBtn.style.opacity = '0.5';
        plusBtn.style.cursor = 'not-allowed';
        plusBtn.title = `Limit reached: ${limit} (all variants combined)`;
        plusBtn.onclick = (e) => e.preventDefault();
      }
    } else {
      if (plusBtn) {
        plusBtn.disabled = false;
        plusBtn.removeAttribute('aria-disabled');
        plusBtn.style.opacity = '1';
        plusBtn.style.cursor = 'pointer';
        plusBtn.removeAttribute('title');
        plusBtn.onclick = null;
      }
    }
  }

  // --- INITIALIZATION ---
  function init() {
    initStandardInterception();

    // Observer for Rebuy
    const observer = new MutationObserver(() => {
      if (window.rebuyTimeout) clearTimeout(window.rebuyTimeout);
      window.rebuyTimeout = setTimeout(checkRebuyLimits, 200);
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Initial check
    setTimeout(checkRebuyLimits, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

} ) ();


document.addEventListener('on:cart:after-merge', () => {
  setTimeout(enforceCartQuantityLimits, 30);
});

document.addEventListener('on:cart-drawer:before-open', () => {
  setTimeout(enforceCartQuantityLimits, 50);
});

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('cart-drawer, cart-form')) {
    setTimeout(enforceCartQuantityLimits, 100);
  }
});

document.addEventListener('change', (e) => {
  if (e.target.matches('cart-drawer input[name="updates[]"], cart-drawer input[name="quantity"], cart-form input[name="updates[]"], cart-form input[name="quantity"]')) {
    setTimeout(enforceCartQuantityLimits, 30);
  }
});

document.addEventListener('click', (e) => {
  if (e.target.closest('[data-action="increment"], [data-action="decrement"], .qty-btn-plus, .qty-btn-minus, .quantity__button')) {
    setTimeout(enforceCartQuantityLimits, 30);
  }
});



/* global SideDrawer */
const EXPEDITED_VARIANT_ID = 45043940851765;
let expeditedLock = false;

/**
 * Refresh cart UI sections
 */
async function refreshCartSections() {
  const drawer = document.querySelector('cart-drawer');
  const header = document.querySelector('page-header');

  // Refresh header via Sections API
  if (header?.dataset.sectionId) {
    try {
      const sectionId = header.dataset.sectionId;
      const res = await fetch(`/cart?sections=${sectionId}`);
      const data = await res.json();
      const html = data[sectionId];
      if (html && typeof header.updateFromCartChange === 'function') {
        header.updateFromCartChange(html);
      }
    } catch (e) {
      console.error('Header update error:', e);
    }
  }

  // Refresh drawer via native event
  if (drawer) {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
  }
}

/**
 * Add expedited processing product to cart
 */
async function addExpedited() {
  if (expeditedLock) return;
  expeditedLock = true;

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: EXPEDITED_VARIANT_ID, quantity: 1 })
    });
    await refreshCartSections();
  } catch (e) {
    console.error('addExpedited error:', e);
  } finally {
    expeditedLock = false;
  }
}

/**
 * Remove expedited processing product from cart
 */
async function removeExpedited() {
  if (expeditedLock) return;
  expeditedLock = true;

  try {
    // Fetch current cart to find the line item key
    const cartRes = await fetch('/cart.js');
    const cartData = await cartRes.json();
    
    // Find the line item with matching variant_id
    const lineItem = cartData.items?.find(item => item.variant_id === EXPEDITED_VARIANT_ID);
    
    if (!lineItem) {
      await refreshCartSections();
      return;
    }
    
    // Remove via line item key (required for /cart/change.js)
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItem.key, quantity: 0 })
    });
    
    await refreshCartSections();
  } catch (e) {
    console.error('removeExpedited error:', e);
  } finally {
    expeditedLock = false;
  }
}

/**
 * Attach change listener to expedited checkbox
 */
function initExpeditedCheckbox() {
  const checkbox = document.querySelector('#expedited-processing-checkbox');
  if (!checkbox || checkbox.dataset.listenerAttached) return;
  
  checkbox.dataset.listenerAttached = 'true';
  checkbox.addEventListener('change', async () => {
    if (checkbox.checked) {
      await addExpedited();
    } else {
      await removeExpedited();
    }
  });
}

// Initialize when drawer opens
document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('cart-drawer')?.addEventListener('on:cart-drawer:before-open', initExpeditedCheckbox);
});

// Re-initialize after cart DOM is merged/refreshed
document.addEventListener('on:cart:after-merge', initExpeditedCheckbox);